var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDesktop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.155.764H.845A.846.846 0 000 1.609v8.5c0 .465.38.844.845.844h4.218v.615c0 .564-.458 1.023-1.022 1.023h-.93a.323.323 0 000 .645h7.778a.323.323 0 000-.645h-.93a1.024 1.024 0 01-1.022-1.023v-.615h4.218c.466 0 .845-.379.845-.845V1.61a.846.846 0 00-.845-.845zM5.357 12.59a1.66 1.66 0 00.352-1.023v-.615H8.29v.615c0 .385.132.74.352 1.023H5.357zm7.997-2.483a.2.2 0 01-.2.2H.846a.2.2 0 01-.2-.2V8.412h12.71v1.696zm0-2.342H.646V1.61c0-.11.09-.2.2-.2h12.31c.11 0 .2.09.2.2v6.157z",
    fill: "#949494"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 9.708a.348.348 0 100-.696.348.348 0 000 .696zM7.553 2.987a.323.323 0 00-.456 0l-2.28 2.281a.323.323 0 00.456.457l2.28-2.281a.323.323 0 000-.457zM8.905 4.31a.323.323 0 00-.456 0l-.909.908a.323.323 0 00.457.456l.908-.908a.323.323 0 000-.457z",
    fill: "#949494"
  })));
}

export default __webpack_public_path__ + "./fonts/desktop.d68f2c711a387f9f8c1e44d93fdf6cdc.svg";
export { SvgDesktop as ReactComponent };